import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import routeCollectorLocalitiesService from "services/routeCollectorLocalitiesService";
import routeCollectorService from "services/routeCollectorService";

// List Route
export const useListRouteCollector = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["routeCollectors", payload?.key || "", params?.page, params?.columnFilter, params?.keywords], // Thêm columnFilter và keywords vào query key
    () => routeCollectorService.listRouteCollector(payload),
    {
      enabled: params?.run || false, 
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("routeCollector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

// Create RouteCollector
export const useCreateRouteCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorService.createRouteCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("routeCollector"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("routeCollector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail RouteCollector
export const useDetailRouteCollector = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useQuery(
    ["routeCollector", "detail"],
    () => routeCollectorService.detailRouteCollector(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("routeCollector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

// Update RouteCollector
export const useUpdateRouteCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorService.updateRouteCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("routeCollector"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("routeCollector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Active RouteCollector
export const useActiveRouteCollector = (onSuccess, onError) => {
  const { t } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorService.activeRouteCollector, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.active", {
          target: t("routeCollector"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.active", {
              target: t("routeCollector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Delete RouteCollector
export const useDeleteRouteCollector = (onSuccess, onError) => {
  const { t } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorService.deleteRouteCollector, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.delete", {
          target: t("routeCollector"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.delete", {
              target: t("routeCollector"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useRouteCollectorLocalities = (params, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation();

  return useQuery(
    ["route-collector-localities", params],
    () => routeCollectorLocalitiesService.getRouteCollectorLocalities(params),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.fetch_profile", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      // initialData: [],
      select: response => {
        const { data } = response;

        return {
          items: data?.items || [],
          params: data?._meta || {},
        };
      },
    }
  );
};

export const useClearAllRouteCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorLocalitiesService.clearAllRouteCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.clear", {
          target: "phân bổ tuyến vận chuyển",
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.clear", {
              target: "phân bổ tuyến vận chuyển",
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useClearRouteCollectorOfHub = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["routeCollector"]);
  const { addToast } = useToasts();

  return useMutation(routeCollectorLocalitiesService.clearRouteCollectorOfHub, {
    retry: 0,
    onSuccess: res => {
      if (res?.data?.result) {
        addToast(
          t("message.clear", {
            target: "phân bổ tuyến vận chuyển",
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        if (typeof onSuccess === "function") {
          onSuccess(res);
        }
      } else {
        addToast(
          formConvertErrorMessage(
            res?.data?.message ||
              t("message.clear", {
                target: "phân bổ tuyến vận chuyển",
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(res);
        }
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.clear", {
              target: "phân bổ tuyến vận chuyển",
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
